var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookmarkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.795,
    height: 27.569,
    viewBox: "0 0 20.795 27.569",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_44156",
    "data-name": "Path 44156",
    d: "M18.661,27.069h-.74a3.267,3.267,0,0,1-1.475-1.009q-2.643-2.662-5.3-5.306a1.269,1.269,0,0,0-1.987,0Q6.511,23.4,3.87,26.043a3.332,3.332,0,0,1-1.494,1.027h-.74c-.012-.012-.021-.032-.035-.036A1.972,1.972,0,0,1,0,24.863Q0,13.793,0,2.723c0-.1,0-.194,0-.291A2.446,2.446,0,0,1,1.425.25,6.294,6.294,0,0,1,2.112,0H18.185c.013.011.025.028.04.032a2.5,2.5,0,0,1,2.069,2.691q0,7.754,0,15.508,0,3.421,0,6.842a1.945,1.945,0,0,1-1.42,1.912c-.073.023-.142.055-.213.084M1.6,13.759q0,5.537,0,11.074a2.429,2.429,0,0,0,.006.29.369.369,0,0,0,.559.308,1.158,1.158,0,0,0,.285-.23q2.8-2.791,5.592-5.584a2.851,2.851,0,0,1,4.225,0q2.787,2.783,5.57,5.568a1.6,1.6,0,0,0,.234.213.388.388,0,0,0,.625-.291,2.1,2.1,0,0,0,.006-.264q0-11.06,0-22.121c0-.817-.322-1.142-1.13-1.142H2.742c-.827,0-1.145.32-1.145,1.153q0,5.511,0,11.021",
    transform: "translate(0.249 0.25)",
    fill: "#111",
    stroke: "#111",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkIcon);
export default __webpack_public_path__ + "static/media/bookmark_icon.1f1dd45f38df474c533e3dad2015ddcc.svg";
export { ForwardRef as ReactComponent };